import { BREAKPOINT } from '@ab-core/breakpoints';
import { useIsMobile } from '@ab-core/functions';
import type { Availability } from '@ab-core/graphql/dist';
import { isLoggedIn } from '@ab-core/hooks';
import { cartStore } from '@ab-core/store';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { AvailabilitiesContainer } from './components/availabilitiesContainer';
import { Loader } from './components/loader/loader';

export type AvailabilitiesStylesType = {
    availabilitiesStyles?: {
        isVisible?: boolean;
        showPickupChannels?: boolean;
    };
};

export type StorageType = {
    storageName: STORAGES;
    hasStorage: boolean;
};

export enum STORAGES {
    PHILLIPSBURG = 'phillipsburg'
}

export type AvailabilitiesProps = AvailabilitiesStylesType & {
    availability?: Availability;
    quantityUnit?: string;
    quantity: number;
    customDeliveryInfo?: string;
};

const AvailabilitiesComponent: FC<AvailabilitiesProps> = (props) => {
    const { quantityUnit = 'Stück', quantity, availabilitiesStyles, availability, customDeliveryInfo } = props;
    const isUserLoggedIn = isLoggedIn();
    const isMobile = useIsMobile(BREAKPOINT.SM);

    useEffect(() => {
        if (isUserLoggedIn && availabilitiesStyles?.isVisible) {
            if (!availability) {
                cartStore.setters.setCartButtonDisabled(true);
            } else {
                cartStore.setters.setCartButtonDisabled(false);
            }
        }
    }, [availability, isUserLoggedIn, availabilitiesStyles?.isVisible]);

    if (!availabilitiesStyles?.isVisible) {
        return <></>;
    }

    if (!isUserLoggedIn) {
        return <Text>Um Preise und Verfügbarkeiten abzufragen, melden Sie sich an.</Text>;
    }

    return (
        <>
            {availability ? (
                <AvailabilitiesContainer
                    {...availability}
                    quantityUnit={quantityUnit}
                    quantity={quantity}
                    showPickupChannels={availabilitiesStyles?.showPickupChannels}
                    customDeliveryInfo={customDeliveryInfo}
                />
            ) : (
                <Loader counter={isMobile ? 2 : 4} testId="product-card-availability-loader" />
            )}
        </>
    );
};

export const Availabilities = React.memo(AvailabilitiesComponent);
